import React from "react";
import styled from "@emotion/styled";

const MainContainer = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, islayout }) => ({
  flexGrow: 1,
  minWidth: 0,
  position: "relative",
  padding: islayout === "true" ? 0 : theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-260px`,
  height: "100vh",
  background: islayout === "true" ? "white" : "#f8f9fa",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

export default MainContainer;
